import React, { useCallback, useEffect, useState } from "react";
import FollowersCard from "../FollowersCard/FollowersCard";
import styles from "./FollowersList.module.scss";
// import { useParams } from "react-router-dom";
import { API } from "../../../service/Interceptor";
import toast from "../../Toast/toast";
import SpinnerLoader from "../../UI/SpinnerLoader/SpinnerLoader";
import CrossIconSVG from "components/SVGComponents/CrossIconSVG";
import noFollowImg from "../../../images/errorImages/noFollowers.png";

const PER_PAGE = 10;

//add modalType in the object destructuring.
const FollowersList = ({ modalType, userId, onClose }) => {
  const [showMore, setShowMore] = useState(false);
  const [followFollowingCount, setFollowFollowingCount] = useState(0);
  const [followerList, setFollowerList] = useState([]);
  const [followingList, setFollowingList] = useState([]);
  const [loadingFollowers, setLoadingFollowers] = useState(false);
  const [loadingFollowing, setLoadingFollowing] = useState(false);
  const [pageNoFollowers, setPageNoFollowers] = useState(1);
  const [pageNoFollowing, setPageNoFollowing] = useState(1);

  const fetchFollowers = useCallback(
    async (page) => {
      if (loadingFollowers) return;

      setLoadingFollowers(true);
      try {
        const res = await API.get(`api/users/${userId}/followers`, {
          params: { perPage: PER_PAGE, pageNo: page },
        });
        if (res?.data?.success === true) {
          setFollowFollowingCount(res?.data?.data?.totalRecord);
          setFollowerList((prev) => [
            ...prev,
            ...(res?.data?.data?.results || []),
          ]);
        } else {
          toast.error(res?.data?.message);
        }
      } catch (error) {
        console.log(error);
        toast.error("Error Occurred while getting followers");
      } finally {
        setLoadingFollowers(false);
      }
    },
    [userId, loadingFollowers],
  );

  const fetchFollowing = useCallback(
    async (page) => {
      if (loadingFollowing) return;
      setLoadingFollowing(true);
      try {
        const res = await API.get(`api/users/${userId}/followings`, {
          params: { perPage: PER_PAGE, pageNo: page },
        });
        if (res?.data?.success === true) {
          setFollowFollowingCount(res?.data?.data?.totalRecord);
          setFollowingList((prev) => [
            ...prev,
            ...(res?.data?.data?.results || []),
          ]);
        } else {
          toast.error(res?.data?.message);
        }
      } catch (error) {
        console.log(error);
        toast.error("Error Occurred while getting followings");
      } finally {
        setLoadingFollowing(false);
      }
    },
    [userId, loadingFollowing],
  );

  useEffect(() => {
    if (modalType === "FOLLOWERS") fetchFollowers(1);
    if (modalType === "FOLLOWING") fetchFollowing(1);
  }, []);

  /* ---------------- SCROLL HANDLER ---------------- */
  const handleScroll = useCallback(
    (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;

      // Trigger when 50px from bottom for smoother experience
      if (scrollHeight - scrollTop <= clientHeight + 50) {
        if (
          modalType === "FOLLOWERS" &&
          !loadingFollowers &&
          pageNoFollowers * PER_PAGE < followFollowingCount
        ) {
          setShowMore(true); // Automatically show more if they are scrolling
          const nextPage = pageNoFollowers + 1;
          setPageNoFollowers(nextPage);
          fetchFollowers(nextPage);
        }

        if (
          modalType === "FOLLOWING" &&
          !loadingFollowing &&
          pageNoFollowing * PER_PAGE < followFollowingCount
        ) {
          setShowMore(true); // Automatically show more if they are scrolling
          const nextPage = pageNoFollowing + 1;
          setPageNoFollowing(nextPage);
          fetchFollowing(nextPage);
        }
      }
    },
    [
      modalType,
      loadingFollowers,
      loadingFollowing,
      pageNoFollowers,
      pageNoFollowing,
      followFollowingCount,
      fetchFollowers,
      fetchFollowing,
    ],
  );

  const showMoreLess = () => {
    setShowMore((prev) => !prev);
  };

  return (
    <div>
      <div className={styles.FollowersList}>
        <div className={styles.cross} onClick={() => onClose()}>
          <CrossIconSVG />
        </div>
        <div className={styles.headerText}>
          {modalType === "FOLLOWERS" && <p>{followFollowingCount} Followers</p>}
          {modalType === "FOLLOWING" && <p>{followFollowingCount} Following</p>}

          <p onClick={showMoreLess}>{showMore ? "See few" : "See all"}</p>
        </div>

        {modalType === "FOLLOWERS" && (
          <div className={styles.followerlist} onScroll={handleScroll}>
            {followerList?.length === 0 && !loadingFollowers && (
              <div className={styles.noFollow}>
                <img src={noFollowImg} alt="" className={styles.followImg} />
                <p className={styles.no_follow_text}>No followers yet</p>
              </div>
            )}

            {(showMore ? followerList : followerList?.slice(0, 8))?.map(
              (follower, index) => (
                <FollowersCard key={index} {...follower} />
              ),
            )}

            {loadingFollowers && (
              <div className={styles.loadingContainer}>
                <SpinnerLoader />
              </div>
            )}
          </div>
        )}

        {modalType === "FOLLOWING" && (
          <div className={styles.followerlist} onScroll={handleScroll}>
            {followingList?.length === 0 && !loadingFollowing && (
              <div className={styles.noFollow}>
                <img src={noFollowImg} alt="" className={styles.followImg} />
                <p className={styles.no_follow_text}>No following yet</p>
              </div>
            )}

            {(showMore ? followingList : followingList?.slice(0, 8))?.map(
              (follower, index) => (
                <FollowersCard key={index} {...follower} />
              ),
            )}

            {loadingFollowing && (
              <div className={styles.loadingContainer}>
                <SpinnerLoader />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FollowersList;
